import { render, staticRenderFns } from "./AnamnesiEditComponent.vue?vue&type=template&id=ab94f24c"
import script from "./AnamnesiEditComponent.vue?vue&type=script&lang=js"
export * from "./AnamnesiEditComponent.vue?vue&type=script&lang=js"
import style0 from "./AnamnesiEditComponent.vue?vue&type=style&index=0&id=ab94f24c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports